export default {"src":"/_next/static/media/google-tag-manager.6b2b12b3.svg","height":106,"width":260,"blurWidth":0,"blurHeight":0};